let pendingQuestionnairePersistence: Promise<unknown> = Promise.resolve();

export function trackQuestionnairePersistence(promise: Promise<unknown>): Promise<unknown> {
  pendingQuestionnairePersistence = promise.catch(function whenFailedToPersistQuestionnaire(error) {
    console.error("Failed to persist questionnaire", error);
    return undefined;
  });

  return promise;
}

export function awaitPendingQuestionnairePersistence(): Promise<unknown> {
  return pendingQuestionnairePersistence;
}
